import FieldItem from "pages/ManagementPage/candiateInfoPreview/FieldItem/FieldItem";

export default FieldItem;
